import styled from 'styled-components'

export const ManagePickupTimesSectionTitleWrapper = styled.div`
  margin: 33px 0 0 0;
  overflow: hidden;

  .title {
    float: left;
  }

  .add-new-time {
    float: right;
  }
`
